<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <div style="width:280px">
        <NeList ref='neList' :neArr='netype' :select='neClick' :typeCode="10006"></NeList>
      </div>
    </template>
    <template v-slot:right_view>
      <PDNProfileTableMenu @methodEnum='methodEnum'></PDNProfileTableMenu>
      <PDNProfileTable ref="pdnProfileTable"></PDNProfileTable>
    </template>
  </BasicLayout>
</template>

<script>
import PDNProfileTable from '../../../../components/subscriberconfig/epcSubscriber/pdn/PDNProfileTable';
import PDNProfileTableMenu from '../../../../components/subscriberconfig/epcSubscriber/pdn/PDNProfileTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'PDNMainPage',
  components: {
    NeList,
    PDNProfileTable,
    PDNProfileTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('PDN.nelist'),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('PDN.crumb'),
      },
      netype: [4],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.pdnProfileTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.pdnProfileTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.pdnProfileTable.delProfiles();
          break;
        case 'qry':
          this.$refs.pdnProfileTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.pdnProfileTable.getGridData(this.$refs.neList.getNe());
    }
  },
};
</script>

<style scoped>

</style>
